module.exports = __webpack_public_path__ + "img/shareimg.57179864.png";